import { render, staticRenderFns } from "./ModuleHeader.vue?vue&type=template&id=34768279&scoped=true"
import script from "./ModuleHeader.vue?vue&type=script&lang=js"
export * from "./ModuleHeader.vue?vue&type=script&lang=js"
import style0 from "./ModuleHeader.vue?vue&type=style&index=0&id=34768279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34768279",
  null
  
)

export default component.exports